/* eslint-disable no-useless-return */
/* eslint-disable prefer-arrow-callback */
class Bookmarks {
  constructor({ buttons } = {}) {
    this.buttons = document.querySelectorAll(buttons || '.bookmark');

    this.events();
  }

  click(item) {
    this.buttons.forEach(
      (element) => {
        const content = document.querySelector(element.dataset.content);
        if (!content) {
          return;
        }

        content.classList.add('d-none');
        element.classList.remove('--active');
      },
    );

    item.classList.add('--active');
    const itemContent = document.querySelector(item.dataset.content);
    if (!itemContent) {
      return;
    }

    itemContent.classList.remove('d-none');
  }

  events() {
    const self = this;
    this.buttons.forEach(
      (element) => element.addEventListener('click', function clickButton() {
        self.click(this);
      }),
    );
  }
}

export default Bookmarks;
